/* DESCONEXIÓN — capa extra: titulares por palabras y franja que reacciona al scroll.
   Igual que dx-motion.js, solo actúa si <html> tiene .dx-anim. */
(() => {
  const html = document.documentElement;
  if (!html.classList.contains('dx-anim') || !('IntersectionObserver' in window)) return;

  /* Titulares de sección: cada palabra sube desde su propia máscara cuando el titular entra */
  const RETRASO_PALABRA = 60;

  function partirPalabras(titulo) {
    /* Solo los que se revelan al entrar: si no, las palabras se quedarían escondidas */
    if (titulo.dataset.dxPalabras || !titulo.closest('[data-dx-revelar]')) return;
    let n = 0;
    const recorrer = (padre) => {
      for (const nodo of [...padre.childNodes]) {
        if (nodo.nodeType === Node.ELEMENT_NODE) {
          recorrer(nodo);
          continue;
        }
        if (nodo.nodeType !== Node.TEXT_NODE || !nodo.textContent.trim()) continue;
        const frag = document.createDocumentFragment();
        nodo.textContent.split(/(\s+)/).forEach((trozo) => {
          if (!trozo) return;
          if (/^\s+$/.test(trozo)) {
            frag.append(trozo);
            return;
          }
          const caja = document.createElement('span');
          caja.className = 'dx-palabra';
          const dentro = document.createElement('span');
          dentro.textContent = trozo;
          dentro.style.setProperty('--dx-d', `${120 + n++ * RETRASO_PALABRA}ms`);
          caja.append(dentro);
          frag.append(caja);
        });
        nodo.replaceWith(frag);
      }
    };
    recorrer(titulo);
    titulo.dataset.dxPalabras = 'true';
  }

  /* Franja: la velocidad del scroll acelera la cinta (o la invierte al subir) y la inclina */
  const franjas = new Set();
  let ultimoY = window.scrollY;
  let velocidad = 0;
  let ritmo = 1;
  let enMarcha = false;

  const animacionDe = (franja) => franja.querySelector('.dx-franja__pista')?.getAnimations()[0];

  function paso() {
    const y = window.scrollY;
    velocidad += (y - ultimoY - velocidad) * 0.2;
    ultimoY = y;

    const objetivo = 1 + Math.max(-5, Math.min(4, velocidad * 0.15));
    ritmo += (objetivo - ritmo) * 0.1;
    const sesgo = Math.max(-8, Math.min(8, velocidad * -0.3));

    franjas.forEach((franja) => {
      const animacion = animacionDe(franja);
      if (animacion) animacion.playbackRate = ritmo;
      franja.style.setProperty('--dx-sesgo', `${sesgo.toFixed(2)}deg`);
    });

    if (Math.abs(ritmo - 1) < 0.01 && Math.abs(velocidad) < 0.05) {
      franjas.forEach((franja) => {
        const animacion = animacionDe(franja);
        if (animacion) animacion.playbackRate = 1;
        franja.style.removeProperty('--dx-sesgo');
      });
      ritmo = 1;
      velocidad = 0;
      enMarcha = false;
      return;
    }
    requestAnimationFrame(paso);
  }

  function arrancar() {
    if (enMarcha || !franjas.size) return;
    enMarcha = true;
    ultimoY = window.scrollY;
    requestAnimationFrame(paso);
  }

  const observadorFranja = new IntersectionObserver((entradas) => {
    entradas.forEach((e) => (e.isIntersecting ? franjas.add(e.target) : franjas.delete(e.target)));
  });

  window.addEventListener('scroll', arrancar, { passive: true });

  function iniciar(raiz = document) {
    raiz.querySelectorAll('.dx-titulo:not(.dx-hero__titulo)').forEach(partirPalabras);
    raiz.querySelectorAll('.dx-franja').forEach((el) => observadorFranja.observe(el));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => iniciar());
  } else {
    iniciar();
  }

  document.addEventListener('shopify:section:load', (e) => iniciar(e.target));
})();
